import { render, staticRenderFns } from "./MailTemplateHeader.vue?vue&type=template&id=57abfa62&scoped=true"
import script from "./MailTemplateHeader.vue?vue&type=script&lang=js"
export * from "./MailTemplateHeader.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateHeader.vue?vue&type=style&index=0&id=57abfa62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57abfa62",
  null
  
)

export default component.exports